import { useEffect, useState } from "react";
import Api from "../openapi";

export default function useMedicalConditions() {
  const [medicalConditionList, setMedicalConditionList] = useState<string[]>([]);
  useEffect(() => {
    const getMedicalConditions = async () => {
      try {
        const res = await Api.MedicalCondition.getMedicalConditions();
        setMedicalConditionList(res.data);
      } catch (error) {}
    };
    getMedicalConditions();
  }, []);
  return medicalConditionList;
}
